import { z } from 'zod';

import { CurrenciesEnum, CurrencyUtils } from '@anyx/shared-utils';


import { ValueEditorInputProps } from './useValueEditor';

interface UseInputPriceEditorReturnProps {
  currency?: CurrenciesEnum;
  getInputPriceEditorValue: (i?: number) => string | undefined;
  handleInputPriceEditorValueChange: (i?: number) => (price: string) => void;
}

export const useInputPriceEditor = ({
  values,
  handleSingleValue,
  handleMultipleValues,
}: ValueEditorInputProps): UseInputPriceEditorReturnProps => {
  return {
    currency: CurrencyUtils.getCurrentCurrency(),
    getInputPriceEditorValue: (i = 0) => {
      return z.coerce.string().optional().catch('').parse(values?.[i]);
    },
    handleInputPriceEditorValueChange: (i) => {
      if (i === undefined) {
        return (price) => handleSingleValue(price);
      }

      return (price) => handleMultipleValues(price, i);
    },
  };
};
